<template>
  <section class="company-ethical">
    <div :class="{ 'company-more': companyMore }" class="company-title-wrap">
      <h4 class="company-title">{{ $t('menuCompany.ethicalManagement') }}</h4>
    </div>

    <div class="company-box resolutions" :data-id="$t('resolutions.name')">
      <h5 :id="$t('resolutions.name')">{{ $t('resolutions.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_resolutions@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_resolutions@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_resolutions.jpg" :alt="$t('resolutions.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('resolutions.title')" class="company-box-title" />
      <div class="company-box-content">
        <html-view :value="$t('resolutions.paragraph')" class="paragraph" />
        <html-view :value="$t('resolutions.date')" class="date" />
        <p class="sign">
          <img
            src="~@/static/image/sign/kimbeomjun.png"
            srcset="~@/static/image/sign/kimbeomjun@2x.png 2x, ~@/static/image/sign/kimbeomjun@3x.png 3x"
            :alt="$t('resolutions.sign')"
          >
        </p>
      </div>
    </div>
    <div class="company-box declaration" :data-id="$t('declaration.name')">
      <h5 :id="$t('declaration.name')">{{ $t('declaration.name') }}</h5>
      <div class="company-box-image">
        <p>
          <content-slider
            :pc="[require('@/static/image/company/pc/image_declaration@3x.jpg'), require('@/static/image/company/pc/image_declaration_2@3x.jpg')]"
            :m="[require('@/static/image/company/m/image_declaration@3x.jpg'), require('@/static/image/company/m/image_declaration_2@3x.jpg')]"
          />
        </p>
      </div>
      <html-view :value="$t('declaration.title')" class="company-box-title" />
      <div class="company-box-content">
        <html-view :value="$t('declaration.paragraph')" class="paragraph" />
        <html-view :value="$t('declaration.date')" class="date" />
        <p class="sign">
          <img
            src="~@/static/image/sign/kimbongjin.png"
            srcset="~@/static/image/sign/kimbongjin@2x.png 2x, ~@/static/image/sign/kimbongjin@3x.png 3x"
            :alt="$t('declaration.sign')"
          >
        </p>
      </div>
    </div>
    <div class="company-box conduct" :data-id="$t('conduct.name')">
      <h5 :id="$t('conduct.name')">{{ $t('conduct.name') }}</h5>
      <div class="company-box-image">
        <p>
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_conduct@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_conduct@3x.jpg 3x">
            <img src="~@/static/image/company/pc/image_conduct.jpg" :alt="$t('conduct.name')">
          </picture>
        </p>
      </div>
      <html-view :value="$t('conduct.title')" class="company-box-title" />
      <div class="company-box-content">
        <html-view :value="$t('conduct.paragraph1')" class="paragraph paragraph-1" />

        <ol class="conduct-criterion">
          <li><strong>{{ $t('conduct.criterion.item1') }}</strong></li>
          <li><strong>{{ $t('conduct.criterion.item2') }}</strong></li>
          <li><strong>{{ $t('conduct.criterion.item3') }}</strong></li>
        </ol>

        <html-view :value="$t('conduct.paragraph2')" class="paragraph paragraph-2" />

        <div class="conduct-index">
          <p class="conduct-index-title">{{ $t('conduct.ethics') }}</p>
          <ol class="conduct-index-list">
            <li>
              <p><strong><a href="#pledge1">{{ $t('conduct.list.item1.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge1-1">{{ $t('conduct.list.item1-1.title') }}</a></li>
                <li><a href="#pledge1-2">{{ $t('conduct.list.item1-2.title') }}</a></li>
                <li><a href="#pledge1-3">{{ $t('conduct.list.item1-3.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge2">{{ $t('conduct.list.item2.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge2-1">{{ $t('conduct.list.item2-1.title') }}</a></li>
                <li><a href="#pledge2-2">{{ $t('conduct.list.item2-2.title') }}</a></li>
                <li><a href="#pledge2-3">{{ $t('conduct.list.item2-3.title') }}</a></li>
                <li><a href="#pledge2-4">{{ $t('conduct.list.item2-4.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge3">{{ $t('conduct.list.item3.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge3-1">{{ $t('conduct.list.item3-1.title') }}</a></li>
                <li><a href="#pledge3-2">{{ $t('conduct.list.item3-2.title') }}</a></li>
                <li><a href="#pledge3-3">{{ $t('conduct.list.item3-3.title') }}</a></li>
                <li><a href="#pledge3-4">{{ $t('conduct.list.item3-4.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge4">{{ $t('conduct.list.item4.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge4-1">{{ $t('conduct.list.item4-1.title') }}</a></li>
                <li><a href="#pledge4-2">{{ $t('conduct.list.item4-2.title') }}</a></li>
                <li><a href="#pledge4-3">{{ $t('conduct.list.item4-3.title') }}</a></li>
                <li><a href="#pledge4-4">{{ $t('conduct.list.item4-4.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge5">{{ $t('conduct.list.item5.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge5-1">{{ $t('conduct.list.item5-1.title') }}</a></li>
                <li><a href="#pledge5-2">{{ $t('conduct.list.item5-2.title') }}</a></li>
                <li><a href="#pledge5-3">{{ $t('conduct.list.item5-3.title') }}</a></li>
                <li><a href="#pledge5-4">{{ $t('conduct.list.item5-4.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge6">{{ $t('conduct.list.item6.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge6-1">{{ $t('conduct.list.item6-1.title') }}</a></li>
                <li><a href="#pledge6-2">{{ $t('conduct.list.item6-2.title') }}</a></li>
              </ol>
            </li>
            <li>
              <p><strong><a href="#pledge7">{{ $t('conduct.list.item7.title') }}</a></strong></p>
              <ol class="depth-2">
                <li><a href="#pledge7-1">{{ $t('conduct.list.item7-1.title') }}</a></li>
                <li><a href="#pledge7-2">{{ $t('conduct.list.item7-2.title') }}</a></li>
              </ol>
            </li>
          </ol>
        </div>

        <div class="conduct-image conduct-image-2">
          <content-slider
            :default-image="require('@/static/image/company/pc/image_conduct_2.jpg')"
            :pc="[require('@/static/image/company/pc/image_conduct_2@3x.jpg'), require('@/static/image/company/pc/image_conduct_3@3x.jpg')]"
            :m="[require('@/static/image/company/m/image_conduct_2@3x.jpg'), require('@/static/image/company/m/image_conduct_3@3x.jpg')]"
          />
          <!--            <picture>-->
          <!--              <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/image_conduct_2@3x.jpg 3x">-->
          <!--              <source media="(max-width: 750px)" srcset="~@/static/image/company/m/image_conduct_2@3x.jpg 3x">-->
          <!--              <img src="~@/static/image/company/pc/image_conduct_2.jpg">-->
          <!--            </picture>-->
        </div>

        <ol class="conduct-list">
          <li>
            <i id="pledge1" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item1.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item1.content')" tag="small" />
            </div>
            <ol class="depth-2">
              <li>
                <i id="pledge1-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item1-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item1-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge1-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item1-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item1-2.content')" tag="p" />
              </li>
              <li>
                <i id="pledge1-3" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item1-3.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item1-3.content')" tag="p" />
              </li>
            </ol>
          </li>
          <li>
            <i id="pledge2" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item2.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item2.content')" tag="small" />
            </div>
            <ol class="depth-2">
              <li>
                <i id="pledge2-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item2-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item2-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge2-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item2-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item2-2.content')" tag="p" />
              </li>
              <li>
                <i id="pledge2-3" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item2-3.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item2-3.content1')" tag="p" />
                <ol class="list-inside">
                  <html-view :value="$t('conduct.list.item2-3.list.item1')" tag="li" />
                  <html-view :value="$t('conduct.list.item2-3.list.item2')" tag="li" />
                  <html-view :value="$t('conduct.list.item2-3.list.item3')" tag="li" />
                  <html-view :value="$t('conduct.list.item2-3.list.item4')" tag="li" />
                </ol>
                <html-view :value="$t('conduct.list.item2-3.content2')" tag="p" />
              </li>
              <li>
                <i id="pledge2-4" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item2-4.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item2-4.content')" tag="p" />
              </li>
            </ol>
          </li>
          <li>
            <i id="pledge3" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item3.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item3.content1')" tag="small" />
            </div>
            <html-view :value="$t('conduct.list.item3.content2')" tag="p" class="depth-1-paragraph" />
            <ol class="depth-2" :class="{ 'company-more': companyMore }">
              <li>
                <i id="pledge3-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item3-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item3-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge3-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item3-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item3-2.content')" tag="p" />
              </li>
              <li>
                <i id="pledge3-3" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item3-3.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item3-3.content')" tag="p" />
              </li>
              <li>
                <i id="pledge3-4" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item3-4.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item3-4.content')" tag="p" />
              </li>
            </ol>
          </li>
          <li :class="{ 'company-more': companyMore }">
            <i id="pledge4" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item4.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item4.content')" tag="small" />
            </div>
            <ol class="depth-2">
              <li>
                <i id="pledge4-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item4-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item4-1.content')" tag="p" />
                <ol class="list-inside">
                  <html-view :value="$t('conduct.list.item4-1.list.item1')" tag="li" />
                  <html-view :value="$t('conduct.list.item4-1.list.item2')" tag="li" />
                  <html-view :value="$t('conduct.list.item4-1.list.item3')" tag="li" />
                  <html-view :value="$t('conduct.list.item4-1.list.item4')" tag="li" />
                </ol>
              </li>
              <li>
                <i id="pledge4-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item4-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item4-2.content')" tag="p" />
              </li>
              <li>
                <i id="pledge4-3" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item4-3.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item4-3.content')" tag="p" />
              </li>
              <li>
                <i id="pledge4-4" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item4-4.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item4-4.content')" tag="p" />
              </li>
            </ol>
          </li>
          <li :class="{ 'company-more': companyMore }">
            <i id="pledge5" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item5.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item5.content1')" tag="small" />
            </div>
            <html-view :value="$t('conduct.list.item5.content2')" tag="p" class="depth-1-paragraph" />
            <ol class="depth-2">
              <li>
                <i id="pledge5-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item5-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item5-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge5-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item5-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item5-2.content')" tag="p" />
              </li>
              <li>
                <i id="pledge5-3" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item5-3.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item5-3.content')" tag="p" />
                <ol class="list-inside">
                  <html-view :value="$t('conduct.list.item5-3.list.item1')" tag="li" />
                  <html-view :value="$t('conduct.list.item5-3.list.item2')" tag="li" />
                  <html-view :value="$t('conduct.list.item5-3.list.item3')" tag="li" />
                </ol>
              </li>
              <li>
                <i id="pledge5-4" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item5-4.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item5-4.content')" tag="p" />
                <ol class="list-inside">
                  <html-view :value="$t('conduct.list.item5-4.list.item1')" tag="li" />
                  <html-view :value="$t('conduct.list.item5-4.list.item2')" tag="li" />
                  <html-view :value="$t('conduct.list.item5-4.list.item3')" tag="li" />
                  <html-view :value="$t('conduct.list.item5-4.list.item4')" tag="li" />
                </ol>
              </li>
            </ol>
          </li>
          <li :class="{ 'company-more': companyMore }">
            <i id="pledge6" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item6.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item6.content')" tag="small" />
            </div>
            <ol class="depth-2">
              <li>
                <i id="pledge6-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item6-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item6-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge6-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item6-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item6-2.content')" tag="p" />
              </li>
            </ol>
          </li>
          <li :class="{ 'company-more': companyMore }">
            <i id="pledge7" class="target" />
            <div class="depth-1-title">
              <p><strong>{{ $t('conduct.list.item7.title') }}</strong></p>
              <html-view :value="$t('conduct.list.item7.content')" tag="small" />
            </div>
            <ol class="depth-2">
              <li>
                <i id="pledge7-1" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item7-1.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item7-1.content')" tag="p" />
              </li>
              <li>
                <i id="pledge7-2" class="target" />
                <div class="depth-2-title">
                  <p><strong>{{ $t('conduct.list.item7-2.title') }}</strong></p>
                </div>
                <html-view :value="$t('conduct.list.item7-2.content')" tag="p" />
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
    <div class="company-box closing" :class="{ 'company-more': companyMore }">
      <html-view :value="$t('closing.title')" class="company-box-title" />
      <div class="company-box-content">
        <html-view :value="$t('closing.paragraph')" tag="p" class="paragraph" />
      </div>
    </div>
    <div :class="{ 'company-more': companyMore }" class="company-box counsel">
      <html-view :value="$t('counsel.title')" class="company-box-title" />
      <div class="company-box-content">
        <div class="counsel-box">
          <p class="table-caption">{{ $t('counsel.table.caption') }}</p>
          <table class="table">
            <colgroup>
              <col>
              <col style="width:20%">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">{{ $t('counsel.table.th1') }}</th>
                <th scope="col">{{ $t('counsel.table.th2') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('counsel.table.td1') }}</td>
                <td class="center">{{ $t('counsel.table.td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td3') }}</td>
                <td class="center">{{ $t('counsel.table.td4') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td5') }}</td>
                <td class="center">{{ $t('counsel.table.td6') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td7') }}</td>
                <td class="center">{{ $t('counsel.table.td8') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td9') }}</td>
                <td class="center">{{ $t('counsel.table.td10') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td11') }}</td>
                <td class="center">{{ $t('counsel.table.td12') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td13') }}</td>
                <td class="center">{{ $t('counsel.table.td14') }}</td>
              </tr>
              <tr>
                <td>{{ $t('counsel.table.td15') }}</td>
                <td class="center">{{ $t('counsel.table.td16') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="counsel-box">
          <html-view :value="$t('credo.title')" tag="p" class="counsel-box-title" />
          <html-view :value="$t('credo.paragraph')" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {
    contentSlider: () => import('@/components/base/ContentSlider')
  },
  props: {
    companyMore: {
      type: Boolean,
      default: true
    }
  },
}
</script>
